<div class="crp-overlay" *ngIf="visible" (click)="onClose()">
  <div class="crp-popup" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="crp-header">
      <div class="crp-header-title">
        <div class="crp-header-icon">
          <i class="fas fa-file-excel"></i>
        </div>
        <div>
          <h3>Chiusura Resi da Excel</h3>
          <p>Carica il file con i resi da chiudere</p>
        </div>
      </div>
      <button type="button" class="crp-close-btn" (click)="onClose()" title="Chiudi">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="crp-body">

      <!-- Errore di validazione del file -->
      <div class="crp-error" *ngIf="errorMessage">
        <i class="fas fa-exclamation-triangle"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- Esito dell'invio: prende il posto della dropzone finché non si
           sceglie di caricare un altro file -->
      <div class="crp-result" *ngIf="!showHelp && result">
        <div class="crp-result-head" [class.has-errors]="!isFullyApplied">
          <i class="fas" [ngClass]="isFullyApplied ? 'fa-circle-check' : 'fa-triangle-exclamation'"></i>
          <div>
            <strong>{{ resultTitle }}</strong>
            <span>
              {{ result.appliedRows }} di {{ result.parsedRows }} righe lette hanno chiuso il reso
              con la data indicata nel file.
            </span>
          </div>
        </div>

        <div class="crp-result-counts">
          <div class="crp-result-count">
            <span class="crp-result-count-value">{{ result.parsedRows }}</span>
            <span class="crp-result-count-label">Righe lette</span>
          </div>
          <div class="crp-result-count is-applied">
            <span class="crp-result-count-value">{{ result.appliedRows }}</span>
            <span class="crp-result-count-label">Resi chiusi</span>
          </div>
          <div class="crp-result-count" [class.is-warning]="hasSkippedRows">
            <span class="crp-result-count-value">{{ result.skippedRows }}</span>
            <span class="crp-result-count-label">Righe saltate</span>
          </div>
          <div class="crp-result-count" [class.is-error]="hasErrorRows">
            <span class="crp-result-count-value">{{ result.errorRows }}</span>
            <span class="crp-result-count-label">Righe scartate</span>
          </div>
        </div>

        <!-- Righe valide che non hanno chiuso nulla: reso inesistente, già
             consegnato o già al quinto stato -->
        <div class="crp-result-list" *ngIf="hasSkippedRows">
          <div class="crp-result-list-title">Righe saltate</div>
          <ul>
            <li *ngFor="let item of result.skipped">
              <span class="crp-result-list-row" *ngIf="rowLabel(item)">{{ rowLabel(item) }}</span>
              <span class="crp-result-list-reason">{{ rowReason(item) }}</span>
            </li>
          </ul>
        </div>

        <!-- Righe malformate, col motivo restituito dal backend -->
        <div class="crp-result-list is-error" *ngIf="hasErrorRows">
          <div class="crp-result-list-title">Righe scartate</div>
          <ul>
            <li *ngFor="let item of result.errors">
              <span class="crp-result-list-row" *ngIf="rowLabel(item)">{{ rowLabel(item) }}</span>
              <span class="crp-result-list-reason">{{ rowReason(item) }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Guida al formato del file, in alternativa alla dropzone -->
      <div class="crp-help" *ngIf="showHelp">
        <p class="crp-help-intro">
          Il file Excel deve avere la <strong>riga di intestazione</strong> e queste colonne, nell'ordine:
        </p>

        <!-- Anteprima visuale del file atteso -->
        <div class="crp-help-table-wrapper">
          <table class="crp-help-table">
            <thead>
              <tr>
                <th *ngFor="let column of exampleHeader">{{ column }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of exampleRows">
                <td *ngFor="let cell of row">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ul class="crp-help-fields">
          <li>
            <i class="fas fa-box-open"></i>
            <div><strong>Codice Reso</strong><span>Il codice del reso da chiudere</span></div>
          </li>
          <li>
            <i class="fas fa-barcode"></i>
            <div><strong>Codice Bolla</strong><span>La bolla a cui il reso è associato</span></div>
          </li>
          <li>
            <i class="fas fa-store"></i>
            <div><strong>Codice Dealer</strong><span>Il dealer del reso</span></div>
          </li>
          <li>
            <i class="fas fa-clock"></i>
            <div><strong>Data</strong><span>Data e ora di chiusura, formato gg/mm/aaaa hh:mm</span></div>
          </li>
        </ul>

        <div class="crp-help-download">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="downloadExampleFile()">
            <i class="fas fa-file-excel me-1 text-success"></i> Scarica file di esempio
          </button>
        </div>
      </div>

      <!-- Dropzone: visibile finché non c'è un file scelto -->
      <div class="crp-dropzone"
           *ngIf="!showHelp && !result && !selectedFile"
           [class.drag-over]="isDragOver"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)">
        <i class="fas fa-cloud-upload-alt crp-dropzone-icon"></i>
        <p class="crp-dropzone-text">Trascina qui il file Excel</p>
        <p class="crp-dropzone-or">oppure</p>
        <label class="btn btn-outline-secondary btn-sm crp-file-btn">
          <i class="fas fa-folder-open me-1"></i> Scegli file
          <input type="file" accept=".xlsx,.xls" (change)="onFileInputChange($event)" hidden>
        </label>
        <p class="crp-dropzone-hint">Formati accettati: .xlsx, .xls — max 10 MB</p>
      </div>

      <!-- File scelto -->
      <div class="crp-file" *ngIf="!showHelp && !result && selectedFile">
        <div class="crp-file-icon">
          <i class="fas fa-file-excel"></i>
        </div>
        <div class="crp-file-info">
          <span class="crp-file-name" [title]="selectedFile.name">{{ selectedFile.name }}</span>
          <span class="crp-file-size">{{ selectedFileSizeLabel }}</span>
        </div>
        <button type="button" class="crp-file-remove" (click)="removeFile()"
                [disabled]="isUploading" title="Rimuovi file">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="crp-footer">
      <!-- A sinistra: alterna guida sul formato e caricamento -->
      <button type="button" class="btn btn-outline-secondary btn-sm"
              *ngIf="!result"
              (click)="toggleHelp()"
              [disabled]="isUploading"
              [title]="showHelp ? 'Torna al caricamento del file' : 'Come deve essere fatto il file'">
        <i class="fas me-1" [ngClass]="showHelp ? 'fa-arrow-left' : 'fa-circle-info'"></i>
        {{ showHelp ? 'Torna al caricamento' : 'Formato del file' }}
      </button>

      <!-- Dopo un esito il pulsante di sinistra riporta alla scelta del file -->
      <button type="button" class="btn btn-outline-secondary btn-sm"
              *ngIf="result"
              (click)="loadAnotherFile()"
              title="Carica un altro file">
        <i class="fas fa-arrow-left me-1"></i> Carica un altro file
      </button>

      <div class="crp-footer-actions">
        <button type="button" class="btn btn-outline-secondary btn-sm"
                (click)="onClose()" [disabled]="isUploading">
          {{ result ? 'Chiudi' : 'Annulla' }}
        </button>
        <button type="button" class="btn btn-sm crp-submit-btn"
                *ngIf="!result"
                (click)="onSubmit()" [disabled]="!selectedFile || showHelp || isUploading">
          <i class="fas me-1" [ngClass]="isUploading ? 'fa-spinner fa-spin' : 'fa-arrow-up'"></i>
          {{ isUploading ? 'Invio in corso...' : 'Carica file' }}
        </button>
      </div>
    </div>
  </div>
</div>
